export default [
  {
    path: 'ship-fee-order',
    name: 'list-ship-fee-order',
    component: () =>
      import(/* webpackChunkName: "list-ship-fee-order" */ './List.vue'),
    meta: {
      title: 'Công nợ phí ship đơn hàng - Clickbuy',
    },
  },
];
